<template>
  <div id="missionStatement">
    <!-- Mission Statement -->
    <v-card flat id="buttonShadow" class=" pb-2">
      <v-layout column align-center justify-center class="grey lighten-4 pb-1" > 
        <span class="title font-weight-regular align-center">Mission Statement   </span>
      </v-layout>
 
      <v-container px-5>
        <v-row class="text-justify text-sm-body-2">
          <span class="font-weight-light" v-html="school.mission_statement"></span>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["school"],
  data () {
    return  {

    }
  }
}
</script>

<style scoped>
 .card {
    border-radius: 10px;
  }

  #buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
.progress-circular {
  text-align: center;
}

#nonScience {
  font-size: 10px;
}

.value {
  margin-left: 150px;
}

.percentageValue {
  color: rgb(85, 85, 85);
  font-size: 14px;
}
</style>





// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/MissionStatement.vue